module.exports = __webpack_public_path__ + "static/img/0010-1未启用吉林市人民政府.f4a196f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0010-1未启用吉林市人民政府.jpg
// module id = ADXp
// module chunks = 0